import React from 'react';

/**
 * SimpleDataGridItem
 * Renders a two-cell row in SimpleDataGrid. Accepts a label prop and a value prop.
 */
const SimpleDataGridItem = ({ label, value, labelClassName = '', valueClassName = '' }) => {
    const labelClasses = ['font-medium', 'text-gray-700', labelClassName]
        .filter(Boolean)
        .join(' ');

    const valueClasses = [valueClassName].filter(Boolean).join(' ');

    const isEmpty = (v) => v === null || v === undefined || v === '';
    const content = isEmpty(value) ? '-' : value;

    return (
        <>
            <div className={labelClasses}>{label}</div>
            <div className={valueClasses}>{content}</div>
        </>
    );
};

export default SimpleDataGridItem;
